import React from "react";
import UnconfiguredComponent from "../common3/UnconfiguredComponent";
import SecondGuardian from "./index";

const sampleGuardian = {
  name: "Förnamn Efternamn",
  socialSecurityNumber: "19800101-1111",
  address: "Storgatan 1",
  zipCode: "123 45",
  city: "Storstaden",
};

export default (props) => {
  const { extra = {}, nodes = {} } = props;
  const { childSelectorName = undefined } = extra;

  const childSelector = Object.values(nodes).find(
    ({ extra = {} }) => extra.name === childSelectorName
  );

  if (!childSelectorName || !childSelector) {
    return (
      <UnconfiguredComponent hint="Please enter name of existing ChildSelector" />
    );
  }

  if (childSelector.extra.multiSelect) {
    return (
      <UnconfiguredComponent hint="SecondGurardian will only work with single select ChildSelector" />
    );
  }

  return (
    <SecondGuardian
      {...props}
      formData={{}}
      save={() => {}}
      sampleGuardian={sampleGuardian}
    />
  );
};
